import { defineMessages } from 'react-intl';
export default defineMessages({
    alreadyPremium: {
        id: 'premium.alreadyPremium',
        defaultMessage: 'You already have a premium account!'
    },
    bestValue: {
        id: 'premium.bestValue',
        defaultMessage: 'Best Value'
    },
    billingDetailsAndroid: {
        id: 'premium.billingDetailsAndroid',
        defaultMessage: 'Free trial: you will not be charged if you cancel at least 24 hours before the trial ends. After that, your SmartMixin subscription renews automatically unless you cancel it at least 24 hours before the end of the current period; you can cancel at any time in your Google Play account settings. Each renewal is charged at the price shown on the button above. Payment is charged to your Google Play account when you confirm your purchase and at the start of each renewal period.'
    },
    billingDetailsIos: {
        id: 'premium.billingDetailsIos',
        defaultMessage: 'Free trial: you will not be charged if you cancel at least 24 hours before the trial ends. After that, your SmartMixin subscription renews automatically unless you cancel it at least 24 hours before the end of the current period; you can cancel at any time in your App Store account settings. Each renewal is charged at the price shown on the button above. Payment is charged to your App Store account when you confirm your purchase and at the start of each renewal period.'
    },
    freeBannerBody: {
        id: 'premium.freeBannerBody',
        defaultMessage: 'Free accounts are served GFS everywhere — your preferred models and "everywhere else" both start working the moment you subscribe.'
    },
    freeBannerTitle: {
        id: 'premium.freeBannerTitle',
        defaultMessage: 'Preferences apply with Premium'
    },
    freeSubscription: {
        id: 'premium.freeSubscription',
        defaultMessage: 'Free premium subscription'
    },
    freeTrialForPeriod: {
        id: 'premium.freeTrialForPeriod',
        defaultMessage: 'Free trial for {period, plural, one {# day} other {# days}}'
    },
    getUnlimitedAccess: {
        id: 'premium.getUnlimitedAccess',
        defaultMessage: 'Get unlimited access to:'
    },
    manageMySubscription: {
        id: 'premium.manageMySubscription',
        defaultMessage: 'Manage my subscription'
    },
    notPurchasedYet: {
        id: 'premium.notPurchasedYet',
        defaultMessage: 'No SmartMixin Premium purchase was found for this store account.'
    },
    orChooseMonthly: {
        id: 'premium.orChooseMonthly',
        defaultMessage: 'Or choose monthly:'
    },
    premium: {
        id: 'premium.premium',
        defaultMessage: 'SmartMixin Premium'
    },
    premiumActive: {
        id: 'premium.premiumActive',
        defaultMessage: 'Active'
    },
    premiumAnnualTrialInfo: {
        id: 'premium.premiumAnnualTrialInfo',
        defaultMessage: 'Start with a free trial of {days, plural, one {# day} other {# days}}'
    },
    premiumCurrentPlan: {
        id: 'premium.premiumCurrentPlan',
        defaultMessage: 'Current Plan'
    },
    premiumDownloadApp: {
        id: 'premium.premiumDownloadApp',
        defaultMessage: 'Download the app to subscribe:'
    },
    premiumEndsOn: {
        id: 'premium.premiumEndsOn',
        defaultMessage: 'Expires on {date}'
    },
    premiumFeatureAlerts: {
        id: 'premium.premiumFeatureAlerts',
        defaultMessage: 'Weather Alerts'
    },
    premiumFeatureAnalysis: {
        id: 'premium.premiumFeatureAnalysis',
        defaultMessage: 'Advanced Weather Analysis'
    },
    premiumFeatureCharts: {
        id: 'premium.premiumFeatureCharts',
        defaultMessage: 'Chart Comparisons'
    },
    premiumFeatureExport: {
        id: 'premium.premiumFeatureExport',
        defaultMessage: 'Data Export'
    },
    premiumFeatureForecast: {
        id: 'premium.premiumFeatureForecast',
        defaultMessage: 'Regional Forecast Models'
    },
    premiumFeatureNotification: {
        id: 'premium.premiumFeatureNotification',
        defaultMessage: 'Status Bar Widget'
    },
    premiumFeatureTitle: {
        id: 'premium.premiumFeatureTitle',
        defaultMessage: 'Premium Feature'
    },
    premiumFeatureWidgets: {
        id: 'premium.premiumFeatureWidgets',
        defaultMessage: 'Home Screen Widgets'
    },
    premiumFreePlan: {
        id: 'premium.premiumFreePlan',
        defaultMessage: 'Free'
    },
    premiumInactive: {
        id: 'premium.premiumInactive',
        defaultMessage: 'Not subscribed'
    },
    premiumManageWebSubscription: {
        id: 'premium.premiumManageWebSubscription',
        defaultMessage: 'Manage your subscription, update payment method, or cancel.'
    },
    premiumManageStoreSubscription: {
        id: 'premium.premiumManageStoreSubscription',
        defaultMessage: 'You subscribed through {store}. Manage or cancel your subscription there.'
    },
    premiumPremiumPlan: {
        id: 'premium.premiumPremiumPlan',
        defaultMessage: 'Premium'
    },
    premiumRenewsOn: {
        id: 'premium.premiumRenewsOn',
        defaultMessage: 'Renews on {date}'
    },
    premiumSubscribeAnnual: {
        id: 'premium.premiumSubscribeAnnual',
        defaultMessage: 'Annual — 9.99 €/year'
    },
    premiumSubscribedOn: {
        id: 'premium.premiumSubscribedOn',
        defaultMessage: 'Subscribed on {platform}'
    },
    premiumSubscribedOnWeb: {
        id: 'premium.premiumSubscribedOnWeb',
        defaultMessage: 'Subscribed on the web'
    },
    premiumSubscribeMonthly: {
        id: 'premium.premiumSubscribeMonthly',
        defaultMessage: 'Monthly — 1.99 €/month'
    },
    premiumSubscribeOnWeb: {
        id: 'premium.premiumSubscribeOnWeb',
        defaultMessage: 'Subscribe now to unlock all premium features.'
    },
    premiumSubscriptionSuccess: {
        id: 'premium.premiumSubscriptionSuccess',
        defaultMessage: 'Your subscription has been activated! Enjoy all premium features.'
    },
    premiumSubscriptionSuccessTitle: {
        id: 'premium.premiumSubscriptionSuccessTitle',
        defaultMessage: 'Welcome to Premium!'
    },
    premiumWebappNotice: {
        id: 'premium.premiumWebappNotice',
        defaultMessage: 'Subscribing on the web is not available right now.'
    },
    pricePerMonth: {
        id: 'premium.pricePerMonth',
        defaultMessage: '{price}/month'
    },
    pricePerYear: {
        id: 'premium.pricePerYear',
        defaultMessage: '{price}/year'
    },
    purchasedNetatmoPro: {
        id: 'premium.purchasedNetatmoPro',
        defaultMessage: 'You previously purchased Netatmo Pro ({date}). It gives you access to a subset of premium features. Subscribe to one of the following offers if you want to have access to all premium features.'
    },
    // Shown when the app store answered a purchase with an error that is not
    // "store unavailable" and not a cancellation (#291).
    purchaseFailed: {
        id: 'premium.purchaseFailed',
        defaultMessage: 'Your purchase could not be completed. Please try again.'
    },
    // Shown when "Restore purchase" fails for a reason other than the store
    // being unavailable (#291).
    restoreFailed: {
        id: 'premium.restoreFailed',
        defaultMessage: 'Your purchases could not be restored. Please try again.'
    },
    restorePurchase: {
        id: 'premium.restorePurchase',
        defaultMessage: 'Restore purchase'
    },
    savingsPercent: {
        id: 'premium.savingsPercent',
        defaultMessage: 'Save {percent}%'
    },
    seePremium: {
        id: 'premium.seePremium',
        defaultMessage: 'See Premium'
    },
    startFreeTrial: {
        id: 'premium.startFreeTrial',
        defaultMessage: 'Start Free Trial'
    },
    // App Store / Google Play could not be reached (no billing connection, no
    // network, or a restore that did not answer within 30 s) (#291).
    storeUnavailable: {
        id: 'premium.storeUnavailable',
        defaultMessage: 'The store is not available right now. Please try again later.'
    },
    subscribeNow: {
        id: 'premium.subscribeNow',
        defaultMessage: 'Subscribe now — no trial'
    },
    switchToPremium: {
        id: 'premium.switchToPremium',
        defaultMessage: 'Switch to SmartMixin Premium'
    },
    thenPrice: {
        id: 'premium.thenPrice',
        defaultMessage: 'then {price}'
    }
});
